import { combineReducers } from 'redux';
import * as ActionTypes from './reports.actionTypes';

const selections = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.TOGGLE_REPORT_SELECTED:
      const { id } = action;
      const selectedIndex = state.indexOf(id);
      let newSelected = [];

      if (selectedIndex === -1) {
        newSelected = newSelected.concat(state, id);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(state.slice(1));
      } else if (selectedIndex === state.length - 1) {
        newSelected = newSelected.concat(state.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          state.slice(0, selectedIndex),
          state.slice(selectedIndex + 1)
        );
      }
      return newSelected;

    case ActionTypes.TOGGLE_REPORT_SELECT_ALL:
      return action.ids;
    default:
      return state;
  }
};

const filters = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.CHANGE_REPORTS_FILTER:
      const { filter, field } = action;
      let filters = state.filter(item => item.field !== field);
      if (filter.value !== 'all') {
        filters.push({
          field: field,
          value: filter,
        });
      }

      return filters;
    default:
      return state;
  }
};

const sortingTerm = (state = { column: '_id', direction: 'desc' }, action) => {
  switch (action.type) {
    case ActionTypes.CHANGE_REPORTS_SORT:
      let direction = 'desc';
      if (action.direction) {
        direction = action.direction;
      } else if (
        state.column === action.sortingTerm &&
        state.direction === 'desc'
      ) {
        direction = 'asc';
      }
      return {
        column: action.sortingTerm,
        direction: direction,
      };
    default:
      return state;
  }
};

const page = (state = 0, action) => {
  switch (action.type) {
    case ActionTypes.CHANGE_REPORTS_PAGE:
      return action.page;
    default:
      return state;
  }
};

const reportsPerPage = (state = 25, action) => {
  switch (action.type) {
    case ActionTypes.CHANGE_REPORTS_PER_PAGE:
      return action.perPage;
    default:
      return state;
  }
};

const search = (state = '', action) => {
  switch (action.type) {
    case ActionTypes.CHANGE_REPORTS_SEARCH:
      return action.search;
    default:
      return state;
  }
};

const reducer = combineReducers({
  selections,
  filters,
  sortingTerm,
  page,
  reportsPerPage,
  search,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/modules/reports/reports.reducer.js